import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installCompactPhoneCopy } from './common/compactPhoneCopy';

// A phone number copied anywhere in the portal reaches the clipboard without
// spaces (+251964540448), ready for MicroSIP.
installCompactPhoneCopy();

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<App/>);